import React from 'react';

// Events
import ShootoutGoal from './Goal';
import ShootoutShotMissed from './ShotMissed';
import ShootoutShotSaved from './ShotSaved';
import Unknown from '../Unknown';


function determineEventComponent({ result: { type }}){
  switch(type){
    case 'goal':
      return ShootoutGoal;
    case 'shotSaved':
      return ShootoutShotSaved;
    case 'shotMissed':
      return ShootoutShotMissed;
    default:
      return Unknown;
  }
}


function ShootoutEvents(props) {
  const Component = determineEventComponent(props.event)
  return <Component {...props} />
}

export default ShootoutEvents;
